const translations = {
  en: {
    nav: {
      about: 'About',
      projects: 'Projects',
      contact: 'Contact',
      openMenu: 'Open navigation menu',
    },
    hero: {
      titleLead: 'Hello, I am',
      description: 'I graduated from Erciyes University, Computer Programming Department. After years of working in IT technical support, front-end, back-end, and CMS applications, I keep up with today\'s software trends through Vibe Coding and develop modern web and mobile applications.',
      projectsButton: 'View My Projects',
      contactButton: 'Get In Touch',
    },
    about: {
      title: 'About Me',
      paragraphs: [
        'After graduating from Erciyes University\'s Computer Programming Department, I completed my mandatory military service working with computers in an office alongside military training. My duties included inventory tracking of military equipment, daily military vehicle assignments, preparing correspondence, reporting, and other paperwork.',
        'After my military service, I worked as an IT support and hardware/software technical service technician at a small company. My responsibilities included cabling, networking, and computer hardware and software support.',
        'I then worked for approximately two years as a front-end and back-end programmer at an IT company. I continued my career as a freelancer for a long time, developing many websites for clients in Turkey and abroad.',
        'Later, I worked for approximately seven years on the PPP Project at Mersin City Hospital, operated under Bilkent Holding, managing card access systems, IT technical support, and progress payment reporting. I processed project data from the hospital information system to produce advanced daily, weekly, and monthly reports and presented them to hospital management.',
        'My journey began with IT technical support, HTML, CSS, ASP, and PHP, and evolved into modern mobile and web technologies. I design and develop minimal, aesthetic, and functional mobile and web applications with user experience at the center.',
      ],
      experience: 'Years of Experience',
    },
    projects: {
      title: 'Some of My Projects',
      intro: 'Projects I have recently worked on and completed. Each combines modern design with technical expertise.',
      viewProject: 'View Project',
      items: [
        {
          id: 1,
          title: 'Android Color Detection and Analysis Assistant',
          description: 'Finding the right color can be one of the most challenging parts of a design process. This application digitizes and professionalizes that process by turning live camera footage or a gallery photo into a technical dataset. Its visual report and PDF sharing features aim to speed up designers\' workflows.',
          tech: ['Kotlin', 'Jetpack Compose', 'CameraX', 'Image Decoder API', 'Android Graphics and Color Analysis'],
          image: '/images/ColorAnalyzer_App1.png',
        },
        {
          id: 2,
          title: 'Minimal and Easy-to-Use Android Reminder App',
          description: 'A SQLite-based reminder application developed with Kotlin and Jetpack Compose (Material 3). It manages scheduled tasks in the background with AlarmManager and BroadcastReceiver and offers users theme options.',
          tech: ['Kotlin', 'Jetpack Compose', 'SQLite', 'AlarmManager', 'BroadcastReceiver'],
          image: '/images/Reminder_App1.png',
        },
      ],
    },
    contact: {
      title: 'Contact',
      intro: 'Feel free to get in touch to discuss new projects and collaboration opportunities.',
      sendMessage: 'Send a Message',
      thanks: 'Thank you!',
      received: 'Your message has been received. I will get back to you as soon as possible.',
      fullName: 'Full Name',
      namePlaceholder: 'Your name',
      email: 'Email',
      message: 'Message',
      messagePlaceholder: 'Your message...',
      send: 'Send',
      social: 'Social Media',
      quickContact: 'Quick Contact',
      location: 'Location',
      responseTime: 'Response Time',
      responseValue: 'Within 24 hours',
    },
    footer: {
      description: 'Modern web and mobile development and design solutions.',
      quickLinks: 'Quick Links',
      home: 'Home',
      contact: 'Contact',
      rights: 'All rights reserved.',
      design: 'Designed and developed by',
    },
    backToTop: 'Back to top',
  },
  tr: {
    nav: {
      about: 'Hakkımda',
      projects: 'Projeler',
      contact: 'İletişim',
      openMenu: 'Navigasyon menüsünü aç',
    },
    hero: {
      titleLead: 'Merhaba, Ben',
      description: 'Erciyes Üniversitesi Bilgisayar Programcılığı Bölümü mezunuyum. Uzun yıllar IT Teknik Servis, Front-End, Back-End ve CMS uygulamaları alanlarında çalıştıktan sonra günümüz yazılım gelişmelerine Vibe Coding ile ayak uydurarak modern web ve mobil uygulamalar geliştiriyorum.',
      projectsButton: 'Örnek Projelerime Bak',
      contactButton: 'Benimle İletişime Geç',
    },
    about: {
      title: 'Hakkımda',
      paragraphs: [
        'Erciyes Üniversitesi Bilgisayar Programcılığı Bölümünden mezun olduktan sonra zorunlu askerlik hizmetimi askeri eğitimlerin yanı sıra yazıhanede bilgisayar başında tamamladım. Görevim askeri malzemeler envanter takibi, günlük askeri araç görevlendirmeleri, yazışmaların hazırlanması, raporlamalar ve diğer evrak işleriydi.',
        'Zorunlu askerlik hizmetim sonrası küçük ölçekli bir firmada IT destek ve donanım yazılım teknik servis teknikerliği yaptım. Kablolama, network, bilgisayar donanım ve yazılım desteği sağladım.',
        'Sonrasında bir bilişim firmasında yaklaşık iki sene Front-End ve Back-End programcı olarak çalıştım. Edindiğim tecrübeyle uzun süre freelance çalışarak yurtiçi ve yurtdışında çok sayıda web sitesi geliştirdim.',
        'Daha sonra Bilkent Holding bünyesindeki Mersin Şehir Hastanesi PPP Projesinde yaklaşık yedi sene; Kartlı Geçiş Sistemleri yönetimi, IT Teknik Destek ve Hakediş Uzmanı olarak çalıştım. Hastane bilgi sistemindeki proje verilerini işleyerek ileri düzey günlük, haftalık ve aylık raporlar hazırladım.',
        'IT Teknik Servis, HTML, CSS, ASP ve PHP ile başlayan yolculuğum modern mobil ve web teknolojilerine evrildi. Kullanıcı deneyimini ön planda tutarak minimal, estetik ve işlevsel mobil/web uygulamaları tasarlıyor ve geliştiriyorum.',
      ],
      experience: 'Yıl Deneyim',
    },
    projects: {
      title: 'Bazı Projelerim',
      intro: 'Son zamanlarda çalıştığım ve tamamladığım projeler. Her biri modern tasarım ve teknik uzmanlığın birleşimi.',
      viewProject: 'Projeyi Görüntüle',
      items: [
        {
          id: 1,
          title: 'Android Mobil Renk Algılama ve Analiz Asistanı',
          description: 'Tasarım süreçlerinde doğru rengi bulmak bazen en zorlayıcı kısımdır. Bu uygulama, kameradan gelen canlı görüntüyü veya galerideki bir fotoğrafı teknik bir veri setine dönüştürerek bu süreci dijitalleştirir. Görsel rapor ve PDF paylaşım özelliği tasarımcıların iş akışını hızlandırmayı hedefler.',
          tech: ['Kotlin', 'Jetpack Compose', 'CameraX', 'Image Decoder API', 'Android Graphics and Color Analysis'],
          image: '/images/ColorAnalyzer_App1.png',
        },
        {
          id: 2,
          title: 'Minimal ve Kullanımı Kolay Android Reminder Uygulaması',
          description: 'Kotlin ve Jetpack Compose (Material 3) kullanılarak geliştirilen SQLite tabanlı bir hatırlatıcı uygulamasıdır. Arka planda AlarmManager ve BroadcastReceiver ile zamanlanmış görevleri yönetir ve tema seçenekleri sunar.',
          tech: ['Kotlin', 'Jetpack Compose', 'SQLite', 'AlarmManager', 'BroadcastReceiver'],
          image: '/images/Reminder_App1.png',
        },
      ],
    },
    contact: {
      title: 'İletişim',
      intro: 'Yeni projeler ve işbirliği fırsatları hakkında konuşmak için benimle iletişime geçin.',
      sendMessage: 'Bir Mesaj Gönderin',
      thanks: 'Teşekkürler!',
      received: 'Mesajınız alındı. En kısa sürede sizinle iletişime geçeceğim.',
      fullName: 'Ad Soyad',
      namePlaceholder: 'Adınız',
      email: 'E-posta',
      message: 'Mesaj',
      messagePlaceholder: 'Mesajınız...',
      send: 'Gönder',
      social: 'Sosyal Medya',
      quickContact: 'Hızlı İletişim',
      location: 'Lokasyon',
      responseTime: 'Cevap Süresi',
      responseValue: '24 saat içinde',
    },
    footer: {
      description: 'Modern web ve mobil geliştirme ve tasarım çözümleri.',
      quickLinks: 'Hızlı Linkler',
      home: 'Ana Sayfa',
      contact: 'İletişim',
      rights: 'Tüm hakları saklıdır.',
      design: 'Tasarım ve geliştirme:',
    },
    backToTop: 'Sayfanın başına git',
  },
};

export default translations;
